import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';

/**
 * Skeleton component for RecipeCategoryHeader.
 * Displays loading placeholders for the category name, subtitle, and category links.
 */
export const RecipeCategoryHeaderSkeleton: FC = () => (
    <div className="relative inset-x-1/2 mx-[-50vw] w-screen bg-slt-deco-purple-50 py-6">
        <div className="mx-auto flex max-w-[1928px] flex-col items-center justify-center gap-4 px-4 sm:px-8 lg:px-10 xl:px-16">
            <div className="flex flex-col items-center gap-1">
                <Skeleton height="48px" width="300px" borderRadius="0" />
                <Skeleton height="24px" width="400px" borderRadius="0" />
            </div>
            <div className="flex w-full items-center justify-center gap-2">
                {Array.from({ length: 6 }, (_, index) => (
                    <Skeleton
                        key={`category-link-skeleton-${index}`}
                        height="40px"
                        width="120px"
                        borderRadius="32px"
                    />
                ))}
            </div>
        </div>
    </div>
);

RecipeCategoryHeaderSkeleton.displayName = 'RecipeCategoryHeaderSkeleton';
